import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Modal, Form } from "react-bootstrap";
import MasterListPage from "./ServiceMasterList";
import ActionDropdown from "Common/ActionDropdown/ActionDropdown";
// import { fetchSalesOrders, exportSalesOrdersCSV } from "slices/salesorder/thunk";
// import PersonAddIcon from "@mui/icons-material/PersonAdd";
import {
  fetchIssuePackingSalesOrderStatusUpdate,
  fetchSalesOrderServiceByType,
  fetchSalesOrderStatusUpdate,
  downloadServiceSalesOrderPdf,
  serviceSalesOrderServiceCompleted,
  downloadCalibrationEngineerPdf,
  downloadRequisitionPdf,
} from "slices/sales_order/thunk";
import { useDispatch } from "react-redux";
import StatusDropdown from "Common/Components/StatusDropdown/statusDropdown";
import { salesOrderStatusOptions } from "Common/Components/StatusDropdown/statusOptions";
import {
  handleProductSalesOrderStatus,
  handleServiceSalesOrderStatus,
  handleRevertServiceSalesOrderStatus,
  handleServiceGeneratePISalesOrder,
} from "slices/sales_order/thunk";
import { DynamicMenuItem } from "Common/Components/DynamicActionMenu/DynamicActionMenu";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import DescriptionIcon from "@mui/icons-material/Description";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import UndoIcon from "@mui/icons-material/Undo";
import VerifiedIcon from "@mui/icons-material/Verified";
import NameWithDate from "Common/Components/NameWithDate.tsx/NameWithDate";
import FormattedDate from "Common/Components/NameWithDate.tsx/FormattedDate";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import { formatIndianAmount } from "helpers/formatIndianAmount";
import { Autocomplete, TextField, Tooltip } from "@mui/material";
import Chip from "components/Chips/Chip";
import StatusChip from "pages/Enquiry/Components/StatusChip";
import { toast } from "react-toastify";
import { MecordColors } from "Constants/Color";
import BootstrapTextField from "Common/Components/InputComponent/BootstrapTextField";
import { Axios } from "api/axios";
import FollowUpPopUp from "components/FollowUpModal/FollowUpPopUp";
import FollowupModel from "components/FollowUpModal/FollowUpModel";
import {
  SALES_ORDER_CATEGORY,
  SALES_ORDER_TYPE,
} from "Constants/StatusConstant";
import {
  showConfirm,
  showError,
  showSuccess,
  showLoading,
  hideLoading,
} from "helpers/swalHelper";
import { app_modules } from "helpers/apps_modules_list";
import usePermission from "hooks/usePermission";
import { CheckCircleIcon } from "lucide-react";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import CancelButton from "Common/Components/Buttons/CancelButton";
import PrimarySubmitButton from "Common/Components/Buttons/PrimarySubmitButton";
import { clearAllTableStates } from "utils/clearTableStates";
import SalesOrderDraft from "./ServiceDraft";

interface SalesOrderPageProps {
  type?: "service"; // Service specific, defaults to service
  noWrapper?: boolean;
}

// Helper function to strip HTML tags from text
const stripHtmlTags = (html: string | null | undefined): string => {
  if (!html) return "-";
  // Remove HTML tags using regex
  const textContent = html.replace(/<[^>]*>/g, "");
  // Decode HTML entities
  const tmp = document.createElement("div");
  tmp.innerHTML = textContent;
  const decodedText = tmp.textContent || tmp.innerText || textContent;
  // Trim whitespace and return, or "N/A" if empty
  return decodedText.trim() || "-";
};

const TAGS_SEARCH_SO_TAB_SERVICE = "TagsSearchSalesOrderServiceTab";

const SalesOrderLog: React.FC<SalesOrderPageProps> = ({ type = "service", noWrapper = false }) => {
  const { tab, tags: tagsParam } = useParams<{ tab?: string; tags?: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch<any>();
  const activeType = "service"; // Hardcoded for service
  const isTagsSearchRoute = location.pathname.startsWith("/tags-search");
  const [tagsSalesOrderTab, setTagsSalesOrderTab] = useState<
    "sales_order_log" | "draft"
  >(() => {
    const stored = sessionStorage?.getItem(TAGS_SEARCH_SO_TAB_SERVICE);
    if (stored === "draft" || stored === "sales_order_log") return stored;
    return "sales_order_log";
  });
  const activeTab = isTagsSearchRoute ? tagsSalesOrderTab : tab;
  const [reloadFlag, setReloadFlag] = useState(0);
  const [tagsTabSummary, setTagsTabSummary] = useState({
    loading: false,
    logCount: 0,
    draftCount: 0,
    hasError: false,
  });
  const tagFromUrl = React.useMemo(() => {
    if (!tagsParam) return "";
    try {
      return decodeURIComponent(tagsParam).trim();
    } catch {
      return tagsParam.trim();
    }
  }, [tagsParam]);
  // Get permissions for service sales orders
  const { canView, canCreate, canUpdate, canDelete } = usePermission(
    app_modules?.sales_order?.app_name,
    app_modules?.sales_order?.modules?.service,
  );

  // Warehouse modal state
  const [showWarehouseModal, setShowWarehouseModal] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState<any>(null);
  const [warehouseOptions, setWarehouseOptions] = useState<any[]>([]);
  const [selectedSalesOrderId, setSelectedSalesOrderId] = useState<string>("");
  const [loadingWarehouses, setLoadingWarehouses] = useState(false);

  // Follow Up Modal  states
  const [showFollowUpModal, setShowFollowUpModal] = useState(false);
  const [selectedFollowUpItem, setSelectedFollowUpItem] = useState<any>(null);

  // Service Completed Modal states
  const [showServiceCompletedModal, setShowServiceCompletedModal] =
    useState(false);
  const [selectedSalesOrderForCompletion, setSelectedSalesOrderForCompletion] =
    useState<any>(null);
  const [serviceCompletedDate, setServiceCompletedDate] = useState<string>("");
  const [serviceCompletedRemark, setServiceCompletedRemark] =
    useState<string>("");
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);

  // Fetch warehouses on component mount
  useEffect(() => {
    const fetchWarehouses = async () => {
      try {
        setLoadingWarehouses(true);
        const response = await Axios.get(
          API_ENDPOINT.MASTERS.WAREHOUSE.DROPDOWN,
        );
        setWarehouseOptions(response.data?.data || []);
      } catch (error) {
        console.error("Failed to fetch warehouses:", error);
        toast.error("Failed to load warehouses");
      } finally {
        setLoadingWarehouses(false);
      }
    };

    fetchWarehouses();
  }, []);

  const persistTagsSearchSoTab = useCallback((v: string) => {
    clearAllTableStates();
    const next = v === "draft" ? "draft" : "sales_order_log";
    setTagsSalesOrderTab(next);
    sessionStorage.setItem(TAGS_SEARCH_SO_TAB_SERVICE, next);
  }, []);

  useEffect(() => {
    return () => {
      if (!window.location.pathname.startsWith("/tags-search")) {
        sessionStorage.removeItem(TAGS_SEARCH_SO_TAB_SERVICE);
      }
    };
  }, []);

  useEffect(() => {
    if (!isTagsSearchRoute || !noWrapper || !tagFromUrl) return;
    let mounted = true;
    setTagsTabSummary((prev) => ({ ...prev, loading: true, hasError: false }));

    Promise.all([
      dispatch(
        fetchSalesOrderServiceByType({
          page: 1,
          pageSize: 1,
          sort: "",
          order: "",
          search: tagFromUrl,
          type: "tag",
          filters: [],
          stage: "orders_log",
        })
      ).unwrap(),
      dispatch(
        fetchSalesOrderServiceByType({
          page: 1,
          pageSize: 1,
          sort: "",
          order: "",
          search: tagFromUrl,
          type: "tag",
          filters: [],
          stage: "draft",
        })
      ).unwrap(),
    ])
      .then(([logRes, draftRes]) => {
        if (!mounted) return;
        setTagsTabSummary({
          loading: false,
          logCount: logRes?.rowCount ?? 0,
          draftCount: draftRes?.rowCount ?? 0,
          hasError: false,
        });
      })
      .catch(() => {
        if (!mounted) return;
        setTagsTabSummary({
          loading: false,
          logCount: 0,
          draftCount: 0,
          hasError: true,
        });
      });

    return () => {
      mounted = false;
    };
  }, [dispatch, isTagsSearchRoute, noWrapper, tagFromUrl, reloadFlag]);

  // dynamic title
  const title =
    activeTab === "sales_order_log"
      ? "Order Log"
      : activeTab === "junk"
        ? "Junk"
        : "Draft";

  // dynamic add label
  const addButtonLabel = "Create Service Order";

  // dynamic add route
  const addRoute = `/sales_order/add_services_sales_order`;

  const handleView = (salesOrderNo: string) => {
    // redirect to single sales order page
    navigate(`/tags-search/sales_order/${activeType}/${activeTab}/view/${salesOrderNo}`);
  };

  const handleEdit = (salesOrderNo: string) => {
    // redirect to edit form
    navigate(`/sales_order/${activeType}/edit/${salesOrderNo}`, {
      state: { tab: activeTab },
    });
  };

  const handleDelete = async (salesOrderNo: string) => {
    const result = await showConfirm(
      "Are you sure you want to delete this sales order?",
      "Delete Sales Order",
      "Yes, Delete",
      "Cancel",
    );

    if (result.isConfirmed) {
      try {
        await dispatch(
          handleRevertServiceSalesOrderStatus(salesOrderNo),
        ).unwrap();
        toast.success("Sales order deleted successfully");
        // Trigger refresh by incrementing reloadFlag
        setReloadFlag((prev) => prev + 1);
      } catch (error: any) {
        toast.error(error?.message || "Failed to delete sales order");
      }
    }
  };

  const handleIssuePacking = (salesOrderNo: string) => {
    // Show warehouse selection modal instead of directly dispatching
    setSelectedSalesOrderId(salesOrderNo);
    setShowWarehouseModal(true);
  };

  const handleWarehouseSubmit = async () => {
    if (!selectedWarehouse) {
      toast.error("Please select a warehouse");
      return;
    }

    try {
      await dispatch(
        fetchIssuePackingSalesOrderStatusUpdate({
          issuePackingPayload: {
            issue_packing: true,
            warehouse_id:
              selectedWarehouse.warehouse_id || selectedWarehouse.id,
          },
          id: selectedSalesOrderId,
        }),
      ).unwrap();

      toast.success("Sales order issued for packing successfully");
      setShowWarehouseModal(false);
      setSelectedWarehouse(null);
      setSelectedSalesOrderId("");
      // Trigger refresh by incrementing reloadFlag
      setReloadFlag((prev) => prev + 1);
    } catch (error: any) {
      console.error("Failed to issue for packing:", error);
      toast.error(error?.message || "Failed to issue for packing");
    }
  };

  const handleWarehouseModalClose = () => {
    setShowWarehouseModal(false);
    setSelectedWarehouse(null);
    setSelectedSalesOrderId("");
  };

  const handleStatusChange = async (
    salesOrderId: string,
    newStatus: string,
    serviceCompletedDate?: string,
    remark?: string,
  ) => {
    try {
      setIsUpdatingStatus(true);

      // Build payload with all required fields
      const payload: any = {
        id: salesOrderId,
        sales_order_stage: "orders_log",
        status: newStatus,
      };

      // Add service completed date and remark if provided
      if (serviceCompletedDate) {
        payload.service_completed_date = serviceCompletedDate;
      }
      if (remark) {
        payload.remark = remark;
      }

      // Make API call directly with the full payload
      const response = await Axios.patch(
        API_ENDPOINT.SALES_ORDER.SERVICE.STATUS_UPDATE(salesOrderId),
        payload,
      );

      toast.success("Status updated successfully");
      setShowServiceCompletedModal(false);
      setServiceCompletedDate("");
      setServiceCompletedRemark("");
      setSelectedSalesOrderForCompletion(null);

      // Refresh the data by triggering a re-fetch
      setReloadFlag((prev) => prev + 1);
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to update status",
      );
    } finally {
      setIsUpdatingStatus(false);
    }
  };

  const handleServiceCompletedClick = (salesOrderData: any) => {
    setSelectedSalesOrderForCompletion(salesOrderData);
    setShowServiceCompletedModal(true);
  };

  const handleServiceCompletedSubmit = async () => {
    if (!selectedSalesOrderForCompletion) {
      toast.error("Sales order data is missing");
      return;
    }

    const salesOrderId =
      selectedSalesOrderForCompletion.sales_order_service_id ||
      selectedSalesOrderForCompletion.id;

    if (!salesOrderId) {
      toast.error("Sales order ID is missing");
      return;
    }

    if (!serviceCompletedDate) {
      toast.error("Please select Service Completed Date");
      return;
    }

    if (!serviceCompletedRemark) {
      toast.error("Please enter a remark");
      return;
    }

    try {
      setIsUpdatingStatus(true);
      await dispatch(
        serviceSalesOrderServiceCompleted({
          id: salesOrderId,
          payload: {
            service_completed_date: serviceCompletedDate,
            remark: serviceCompletedRemark,
          },
        }),
      ).unwrap();

      toast.success("Service completed successfully");
      setShowServiceCompletedModal(false);
      setServiceCompletedDate("");
      setServiceCompletedRemark("");
      setSelectedSalesOrderForCompletion(null);

      // Refresh the data by triggering a re-fetch
      setReloadFlag((prev) => prev + 1);
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to complete service",
      );
    } finally {
      setIsUpdatingStatus(false);
    }
  };

  const handleServiceCompletedModalClose = () => {
    setShowServiceCompletedModal(false);
    setServiceCompletedDate("");
    setServiceCompletedRemark("");
    setSelectedSalesOrderForCompletion(null);
  };

  // Helper function to get status color
  const getStatusColor = (
    status: string,
  ): "default" | "primary" | "success" | "warning" | "error" | "info" => {
    const statusLower = (status || "").toLowerCase();
    if (
      statusLower.includes("in progress") ||
      statusLower.includes("srv created")
    ) {
      return "info";
    } else if (
      statusLower.includes("completed") ||
      statusLower.includes("delivered") ||
      statusLower.includes("closed")
    ) {
      return "success";
    } else if (
      statusLower.includes("pending") ||
      statusLower.includes("on hold")
    ) {
      return "warning";
    } else if (
      statusLower.includes("cancelled") ||
      statusLower.includes("rejected")
    ) {
      return "error";
    }
    return "default";
  };

  // Helper function to get packing status color
  const getPackingStatusColor = (
    status: string,
  ): "default" | "primary" | "success" | "warning" | "error" | "info" => {
    const statusLower = (status || "").toLowerCase();
    if (statusLower.includes("packing initiated")) {
      return "success";
    } else if (
      statusLower.includes("pending issue") ||
      statusLower.includes("pending")
    ) {
      return "warning";
    } else if (
      statusLower.includes("delivered") ||
      statusLower.includes("closed")
    ) {
      return "success";
    } else if (statusLower.includes("on hold")) {
      return "error";
    } else if (statusLower.includes("draft")) {
      return "default";
    }
    return "default";
  };

  const handleDownloadCalibrationEngineerPdf = async (
    salesOrderServiceId: string,
    salesOrderNumber: string,
  ) => {
    try {
      showLoading("Downloading PDF...");
      const res = await dispatch(
        downloadCalibrationEngineerPdf({
          salesOrderServiceId,
          salesOrderNumber,
        }),
      ).unwrap();

      // console.log("Calibration Engineer PDF download response:", res);
      hideLoading();
      if (res) {
        showSuccess("GRN Tech Form PDF downloaded successfully");
      }
    } catch (err: any) {
      hideLoading();
      showError(
        err?.message ||
          err?.error ||
          "Failed to download GRN Tech Form PDF",
      );
    }
  };

  const handleDownloadRequisitionPdf = async (
    salesOrderServiceId: string,
    salesOrderNumber: string,
  ) => {
    try {
      showLoading("Downloading PDF...");
      const res = await dispatch(
        downloadRequisitionPdf({
          salesOrderServiceId,
          salesOrderNumber,
        }),
      ).unwrap();

      // console.log("Requisition PDF download response:", res);
      hideLoading();
      if (res) {
        showSuccess("GRN Admin Form PDF downloaded successfully");
      }
    } catch (err: any) {
      hideLoading();
      showError(
        err?.message || err?.error || "Failed to download GRN Admin Form PDF",
      );
    }
  };

  const getColumns = () => {
    const commonColumns = [
      // {
      //   header: "Sr. No.",
      //   accessorKey: "sr_no",
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   cell: ({ row, table }: { row: any; table: any }) =>
      //     table.getState().pagination.pageIndex *
      //       table.getState().pagination.pageSize +
      //     row.index +
      //     1,
      // },
      {
        header: "SRV No.",
        accessorKey: "sales_order_number",
        enableColumnFilter:   false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.SERVICE.FILTER_DROPDOWN(
          "sales_order_number",
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) =>
          row.original.sales_order_number || "-",
      },
      {
        header: "Service Number",
        accessorKey: "service_number",
        enableColumnFilter:   false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.SERVICE.FILTER_DROPDOWN(
          "service_number",
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => row.original.service_number || "-",
      },
      {
        header: "SRV Date",
        accessorKey: "srv_date",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "date" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.SERVICE.FILTER_DROPDOWN(
          "srv_date",
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => (
          <FormattedDate date={row.original.srv_date} />
        ),
      },
      {
        header: "Quotation Reference",
        accessorKey: "quotation_number",
        enableColumnFilter:   false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.SERVICE.FILTER_DROPDOWN(
          "quotation_number",
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => row.original.quotation_number || "-",
      },

      {
        header: "Customer Name",
        accessorKey: "company_name",
        enableColumnFilter:   false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.SERVICE.FILTER_DROPDOWN(
          "company_name",
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) =>
          row.original.customer_details?.company_name || "-",
      },
      {
        header: "Agent",
        accessorKey: "agent_name",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.SERVICE.FILTER_DROPDOWN(
          "agent_name",
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => row.original.agent_name || "-",
      },

      {
        header: "Grand Total",
        accessorKey: "grand_total_amount",
        enableColumnFilter: false,
        enableSorting: false,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.SERVICE.FILTER_DROPDOWN(
          "grand_total_amount",
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => {
          const val = row.original.grand_total_amount;
          const sym = row.original.currency_symbol || "₹";
          return val != null && val !== "" ? `${sym} ${formatIndianAmount(val)}` : "-";
        },
      },

      {
        header: "Status",
        accessorKey: "sales_order_status",
        id: "sales_order_status",
        enableColumnFilter:   false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.SERVICE.FILTER_DROPDOWN(
          "sales_order_status",
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => {
          const status = row.original.sales_order_status || "-";
          return <StatusChip status={status} />;
        },
      },
      // {
      //   header: "Packing & Dispatch",
      //   accessorKey: "packing_status",
      //   id: "packing_status",
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   cell: ({ row }: { row: any }) => {
      //     const status = row.original.packing_status || "-";
      //     return (
      //       <Chip
      //         label={status}
      //         color={getPackingStatusColor(status)}
      //         size="small"
      //         sx={{
      //           fontWeight: 500,
      //           fontSize: "0.75rem",
      //         }}
      //       />
      //     );
      //   },
      // },
      {
        header: "Assigned To",
        accessorKey: "assigned_members",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.PRODUCT.FILTER_DROPDOWN("assigned_members")}&stage=draft`,

        cell: ({ row }: { row: any }) => {
          const members = row.original?.assigned_members || [];

          if (!members.length) return "-";

          const names = members.map(
            (m: any) =>
              `${m.first_name || ""} ${m.last_name || ""}`.trim() || m.username,
          );

          const visible = names.slice(0, 4);
          const remaining = names.length - visible.length;

          return (
            <Tooltip
              arrow
              placement="top"
              title={names.join("\n")}
              componentsProps={{
                tooltip: {
                  sx: {
                    whiteSpace: "pre-line",
                    maxWidth: 250,
                    fontSize: "13px",
                  },
                },
              }}
            >
              <div style={{ cursor: "pointer", lineHeight: 1.4 }}>
                {visible.map((name: string, index: number) => (
                  <div key={index}>{name}</div>
                ))}

                {remaining > 0 && (
                  <div style={{ fontSize: "12px", color: "#6c757d" }}>
                    +{remaining} more
                  </div>
                )}
              </div>
            </Tooltip>
          );
        },
      },
      {
        header: "Assigned Technician",
        accessorKey: "assigned_technician",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.PRODUCT.FILTER_DROPDOWN("assigned_technician")}&stage=draft`,

        cell: ({ row }: { row: any }) => {
          const technicians = row.original?.assigned_technician || [];

          if (!technicians.length) return "-";

          const names = technicians.map(
            (m: any) =>
              `${m.first_name || ""} ${m.last_name || ""}`.trim() || m.username,
          );

          const visible = names.slice(0, 4);
          const remaining = names.length - visible.length;

          return (
            <Tooltip
              arrow
              placement="top"
              title={names.join("\n")}
              componentsProps={{
                tooltip: {
                  sx: {
                    whiteSpace: "pre-line",
                    maxWidth: 250,
                    fontSize: "13px",
                  },
                },
              }}
            >
              <div style={{ cursor: "pointer", lineHeight: 1.4 }}>
                {visible.map((name: string, index: number) => (
                  <div key={index}>{name}</div>
                ))}

                {remaining > 0 && (
                  <div style={{ fontSize: "12px", color: "#6c757d" }}>
                    +{remaining} more
                  </div>
                )}
              </div>
            </Tooltip>
          );
        },
      },
      // {
      //   header: "PO Date",
      //   accessorKey: "customer_po_date",
      //   id: "customer_po_date",
      //   enableColumnFilter: true,
      //   enableSorting: false,
      //   filterType: "dropdown" as const,
      //   filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.SERVICE.FILTER_DROPDOWN(
      //     "customer_po_date"
      //   )}&stage=orders_log`,
      //   cell: ({ row }: { row: any }) => (
      //     <FormattedDate
      //       date={row.original.customer_details?.customer_po_date}
      //     />
      //   ),
      // },
      {
        header: "Last Followup Date",
        accessorKey: "last_followup_date",
        id: "last_followup_date",
        enableColumnFilter:   false,
        enableSorting: false,
        filterType: "date" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.SERVICE.FILTER_DROPDOWN(
          "last_followup_date",
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => {
          // Get follow-up date from sales_order_follow_ups array
          const followUps = row.original.sales_order_follow_ups || [];
          const lastFollowUp =
            followUps.length > 0 ? followUps[followUps.length - 1] : null;
          const followUpDate = lastFollowUp
            ? lastFollowUp.follow_up_date
            : row.original.last_followup_date;
          return <FormattedDate date={followUpDate} />;
        },
      },
      {
        header: "Followup Remark",
        accessorKey: "followup_remark",
        id: "followup_remark",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.SERVICE.FILTER_DROPDOWN(
          "followup_remark",
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => {
          // Get follow-up remarks from sales_order_follow_ups array
          const followUps = row.original.sales_order_follow_ups || [];
          const lastFollowUp =
            followUps.length > 0 ? followUps[followUps.length - 1] : null;
          const followUpRemark = lastFollowUp
            ? lastFollowUp.follow_up_remarks
            : null;
          // Strip HTML tags from the remark
          const cleanRemark = stripHtmlTags(followUpRemark);
          return (
            <div
              style={{
                whiteSpace: "normal",
                wordWrap: "break-word",
                minWidth: "150px",
              }}
            >
              {cleanRemark}
            </div>
          );
        },
      },
      {
        header: "Next Followup Date",
        accessorKey: "next_followup_date",
        id: "next_followup_date",
        enableColumnFilter:   false,
        enableSorting: false,
        filterType: "date" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.SERVICE.FILTER_DROPDOWN(
          "next_followup_date",
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => {
          // Get next follow-up date from sales_order_follow_ups array
          const followUps = row.original.sales_order_follow_ups || [];
          const lastFollowUp =
            followUps.length > 0 ? followUps[followUps.length - 1] : null;
          const nextFollowUpDate = lastFollowUp
            ? lastFollowUp.next_follow_up_date
            : row.original.next_followup_date;
          return <FormattedDate date={nextFollowUpDate} />;
        },
      },
      {
        header: "Notes",
        accessorKey: "notes",
        enableColumnFilter: false,
        enableSorting: false,
        minSize: 200,
        size: 200,
        cell: ({ row }: { row: any }) => (
          <div
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              maxWidth: "200px",
              minWidth: "200px",
            }}
          >
            {row.original.notes || "-"}
          </div>
        ),
        // filterType: "dropdown" as const,
        // filterFetchUrl: `/sales_order/${activeType}/dynamic_dropdown/notes?stage=orders_log`,
      },
       {
        header: "Tags",
        accessorKey: "tags",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }: { row: any }) => {
          const tags: string[] = row.original.tags || [];
          if (!tags.length) return "-";

          const maxVisible = 3;
          const visible = tags.slice(0, maxVisible);
          const remaining = tags.length - visible.length;
          const tooltipText = tags.join(", ");

          return (
            <Tooltip
              arrow
              placement="top"
              title={tooltipText}
              componentsProps={{
                tooltip: {
                  sx: {
                    maxWidth: 300,
                    fontSize: "13px",
                    whiteSpace: "normal",
                  },
                },
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "4px",
                  minWidth: "150px",
                  cursor: "pointer",
                }}
              >
                {visible.map((tag: string) => (
                  <Chip key={tag}>{tag}</Chip>
                ))}
                {remaining > 0 && <Chip>+{remaining} more</Chip>}
              </div>
            </Tooltip>
          );
        },
      },
      {
        header: "Created By/Date",
        accessorKey: "created_at",
        enableColumnFilter:   false,
        enableSorting: false,
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => {
          const createdByUser = row.original.created_by_user;
          const userName = createdByUser
            ? createdByUser.username || "-"
            : "-";
          return (
            <NameWithDate name={userName} date={row.original.created_at} />
          );
        },
      },
      {
        header: "Updated By/Date",
        accessorKey: "updated_at",
        enableColumnFilter:   false,
        enableSorting: false,
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => {
          const updatedByUser = row.original.updated_by_user;
          const userName = updatedByUser
              ? updatedByUser.username || "-"
            : "-";
          return (
            <NameWithDate name={userName} date={row.original.updated_at} />
          );
        },
      },
    ];

    const actionColumn = {
      header: "Action",
      enableColumnFilter: false,
      enableSorting: false,
      cell: ({ row }: { row: any }) => {
        const sales_order =
          row.original.sales_order_service_id || row.original.id;

        // Check status conditions
        const salesOrderStatus = row.original.sales_order_status;
        const canEdit = salesOrderStatus === "SRV Created";
        const hasQuotationId = !!row.original.quotation_service_id;
        // console.log("pi genereated = >", row.original.pi_generated);
        const isServiceCompleted =
          row.original.sales_order_status !== "Service Completed" &&
          row.original.pi_generated == true;
        // console.log("isServiceCompleted = ", isServiceCompleted);
        const data = row.original;

        const handleDownloadPdf = async (
          id: string,
          salesOrderNumber: string,
        ) => {
          // Show confirmation for Generate PI
          const result = await showConfirm(
            "Are you sure you want to generate PI for this service order?",
            "Generate PI",
            "Yes, Generate",
            "Cancel",
          );

          if (!result.isConfirmed) {
            return;
          }
          try {
            const salesOrderId = data?.sales_order_service_id || data?.id;
            
            await dispatch(
              handleServiceGeneratePISalesOrder(salesOrderId),
            ).unwrap();

            // Dispatch handleServiceGeneratePISalesOrder after successful download
            if (salesOrderId) {
              try {
                showLoading("Downloading PDF...");
                await dispatch(
                  downloadServiceSalesOrderPdf({ id, salesOrderNumber }),
                ).unwrap();
                // Trigger refresh by incrementing reloadFlag
                hideLoading();
                showSuccess("PDF downloaded successfully");
                setReloadFlag((prev) => prev + 1);
              } catch (piError: any) {
                console.error("Error generating PI:", piError);
                // Don't show error to user as PDF was already downloaded successfully
              }
            }
          } catch (err: any) {
            hideLoading();
            console.error("Error downloading PDF:", err);
            showError(err?.message || "Failed to download PDF");
          }
        };

        const actions = [
          ...(canView
            ? [
                {
                  label: "View",
                  permission: canView,
                  icon: <VisibilityIcon fontSize="small" color="info" />,
                  onClick: () => handleView(sales_order),
                },
              ]
            : []),
          // Allow Edit whenever user has Update permission (even when challans are created)
          ...(canUpdate
            ? [
                {
                  label: "Edit",
                  permission: canUpdate,
                  icon: <EditIcon fontSize="small" color="primary" />,
                  onClick: () => handleEdit(sales_order),
                },
              ]
            : []),
          {
            label: "Follow up",
            permission: canUpdate,
            icon: <PersonAddIcon fontSize="small" color="success" />,
            onClick: () => {
              setSelectedFollowUpItem(data);
              setShowFollowUpModal(true);
            },
          },
          {
            label: "Manage Challan",
            permission: canUpdate,
            icon: <PersonAddIcon fontSize="small" color="success" />,
            onClick: () => {
              navigate(`/sales_order/service/challan/${sales_order}`, {
                state: { salesOrderData: data },
              });
            },
          },
          ...(isServiceCompleted
            ? [
                {
                  label: "Service Completed",
                  permission: canUpdate,
                  icon: <VerifiedIcon fontSize="small" color="success" />,
                  onClick: () => handleServiceCompletedClick(data),
                },
              ]
            : []),
          // Show Revert if quotation_service_id exists, otherwise show Delete (only if user has Delete permission)
          ...(canEdit
            ? [
                {
                  label: hasQuotationId ? "Revert" : "Delete",
                  permission: canUpdate,
                  icon: hasQuotationId ? (
                    <UndoIcon fontSize="small" color="warning" />
                  ) : (
                    <DeleteOutlineIcon fontSize="small" color="error" />
                  ),
                  onClick: () => handleDelete(sales_order),
                  className: "text-danger",
                },
              ]
            : []),

          // Only show Issue Packing if not already issued for packing
          // Always show Generate PI (can be generated multiple times) - requires canView
          ...(canView
            ? [
                {
                  label: "Generate PI",
                  permission: canView,
                  icon: (
                    <InsertDriveFileIcon fontSize="small" color="primary" />
                  ),
                  onClick: async () => {
                    handleDownloadPdf(sales_order, data.sales_order_number);
                  },
                },
              ]
            : []),

          ...(canView
            ? [
                {
                  label: "GRN Admin Form PDF",
                  permission: canView,
                  icon: FileDownloadOutlinedIcon,
                  onClick: async () => {
                    handleDownloadRequisitionPdf(
                      sales_order,
                      data.sales_order_number,
                    );
                  },
                  color: "primary",
                },
              ]
            : []),

          ...(canView
            ? [
                {
                  label: "GRN Tech Form PDF",
                  permission: canView,
                  icon: FileDownloadOutlinedIcon,
                  onClick: async () => {
                    handleDownloadCalibrationEngineerPdf(
                      sales_order,
                      data.sales_order_number,
                    );
                  },
                  color: "primary",
                },
              ]
            : []),
        ];

        // return <ActionDropdown actions={actions} />;
        return <DynamicMenuItem row={row.original} menuItems={actions} />;
      },
    };
    return [...commonColumns, actionColumn];
  };

  const hideEntireTagsSection =
    isTagsSearchRoute &&
    noWrapper &&
    !tagsTabSummary.loading &&
    !tagsTabSummary.hasError &&
    tagsTabSummary.logCount === 0 &&
    tagsTabSummary.draftCount === 0;

  if (hideEntireTagsSection) {
    return null;
  }
  const forceShowOnTagsSearch = isTagsSearchRoute && noWrapper && !hideEntireTagsSection;

  if (isTagsSearchRoute && tagsSalesOrderTab === "draft") {
    return (
      <SalesOrderDraft
        type={type}
        tagsSearchActiveTab="draft"
        noWrapper={noWrapper}
        forceShowOnTagsSearch={forceShowOnTagsSearch}
        onTagsSearchTabNavigate={persistTagsSearchSoTab}
      />
    );
  }

  return (
    <>
      <MasterListPage
        title={`Service ${title}`}
        addButtonLabel={addButtonLabel}
        addRoute={addRoute}
        fetchThunk={"fetchSalesOrders"}
        exportThunk={"exportSalesOrdersCSV"}
        columns={getColumns()}
        statusToggleUrl={`/sales-order/service`}
        activeTab={activeTab}
        activeType={"service"}
        handleDelete={handleDelete}
        reloadFlag={reloadFlag}
        noWrapper={noWrapper}
        onTagsSearchTabNavigate={
          isTagsSearchRoute ? persistTagsSearchSoTab : undefined
        }
        forceShowOnTagsSearch={forceShowOnTagsSearch}
      />

      {/* Warehouse Selection Modal */}
      <Modal
        show={showWarehouseModal}
        onHide={handleWarehouseModalClose}
        backdrop="static"
        keyboard={false}
        size="sm"
        centered
      >
        <Modal.Header
          style={{
            backgroundColor: MecordColors?.ThemeBGColor,
            color: "#fff",
          }}
        >
          <Modal.Title>Select Warehouse for Issue Packing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>
              Warehouse <span className="text-danger">*</span>
            </Form.Label>
            <Autocomplete
              options={warehouseOptions}
              getOptionLabel={(option: any) =>
                option?.warehouse_name || option?.name || ""
              }
              value={selectedWarehouse}
              onChange={(_, newValue) => {
                setSelectedWarehouse(newValue);
              }}
              loading={loadingWarehouses}
              renderInput={(params) => (
                <BootstrapTextField
                  {...params}
                  placeholder="Select Warehouse"
                  size="small"
                  error={!selectedWarehouse}
                  helperText={
                    !selectedWarehouse ? "Please select a warehouse" : ""
                  }
                />
              )}
              isOptionEqualToValue={(option, value) =>
                option?.warehouse_id === value?.warehouse_id ||
                option?.id === value?.id
              }
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleWarehouseModalClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleWarehouseSubmit}
            style={{
              backgroundColor: MecordColors?.ThemeBGColor,
              borderColor: MecordColors?.ThemeBGColor,
            }}
            disabled={!selectedWarehouse}
          >
            Issue for Packing
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Follow Up Modal */}
      <FollowUpPopUp
        open={showFollowUpModal}
        onClose={() => {
          setShowFollowUpModal(false);
          setReloadFlag((prev) => prev + 1);
        }}
        title="Follow-up and Activities"
      >
        {selectedFollowUpItem && (
          <FollowupModel
            data={selectedFollowUpItem}
            activeType={SALES_ORDER_TYPE?.SERVICE}
            category={SALES_ORDER_CATEGORY?.OTHERS}
            onClose={() => {
              setShowFollowUpModal(false);
              setReloadFlag((prev) => prev + 1);
            }}
            onSuccess={() => {
              // Trigger refresh by incrementing reloadFlag
              setReloadFlag((prev) => prev + 1);
            }}
          />
        )}
      </FollowUpPopUp>

      {/* Service Completed Modal */}
      <Modal
        show={showServiceCompletedModal}
        onHide={handleServiceCompletedModalClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header
          closeButton
          style={{
            backgroundColor: "#f8f9fa",
            borderBottom: "1px solid #dee2e6",
            paddingBottom: "15px"
          }}
          
        >
          <Modal.Title >
            Add Remark
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>
                Service Completed Date:
              </Form.Label>
              <Form.Control
                type="date"
                value={serviceCompletedDate}
                onChange={(e) => setServiceCompletedDate(e.target.value)}
                placeholder="Select Date (only visible when we select Complete)"
                style={{
                  borderRadius: "8px",
                  border: "1px solid #ced4da",
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label >
                Remark
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={serviceCompletedRemark}
                onChange={(e) => setServiceCompletedRemark(e.target.value)}
                placeholder="Enter Remarks"
                style={{
                  borderRadius: "8px",
                  border: "1px solid #ced4da",
                  resize: "vertical",
                }}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "1px solid #dee2e6",
            padding: "12px 16px",
          }}
        >
          <div className="d-flex justify-content-center w-100 gap-3">
            <CancelButton 
              onClick={handleServiceCompletedModalClose} 
              disabled={isUpdatingStatus}
              showConfirmation={false}
            />

            <PrimarySubmitButton 
              onClick={handleServiceCompletedSubmit}
              disabled={
                isUpdatingStatus ||
                !serviceCompletedDate ||
                !serviceCompletedRemark
              } 
              isLoading={isUpdatingStatus}
            
            />
            {/* <Button
              variant="primary"
              onClick={handleServiceCompletedSubmit}
              disabled={
                isUpdatingStatus ||
                !serviceCompletedDate ||
                !serviceCompletedRemark
              
              }
              style={{
                borderRadius: "8px",
                backgroundColor: "#dc3545",
                borderColor: "#dc3545",
                fontWeight: 600,
                minWidth: "100px",
              }}
            >
              {isUpdatingStatus ? "Submitting..." : "Submit"}
            </Button> */}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SalesOrderLog;
